import { CtaButton, getAspectRatioRate } from '@zappyrent/hundop';
import { cover, rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    position: relative;
    display: flex;
    flex-direction: row;
  }
`;

export const StyledBlocks = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    position: relative;
    display: flex;
    flex-direction: row;
  }
`;

export const StyledCtaButton = styled(CtaButton)`
  text-transform: uppercase;
`;

export const StyledCtaButtonWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    width: ${rem('240px')};
    margin-left: auto;
  }
`;

export const StyledGridWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    position: absolute;
    right: 0;
    left: 0;
  }
`;

export const StyledImage = styled.img`
  ${cover()}
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const StyledImageWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: ${getAspectRatioRate(16, 10)};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('32px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-top: ${getAspectRatioRate(4, 3.8)};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding-top: ${getAspectRatioRate(4, 3.2)};
  }
`;

export const StyledTextBlock = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    align-items: center;
    flex: 0 0 50%;
  }
`;

export const StyledTextWrapper = styled.div`
  width: 100%;
  margin-bottom: ${rem('72px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    width: 50%;
    padding-left: ${rem('80px')};
    margin: 0;
    text-align: right;
  }
`;

export const StyledImageBlock = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex: 0 0 50%;
  }
`;
